import {
  LinkTarget,
  type Subtitle,
  SubtitleClickAction,
  SubtitleRollingMode,
} from '@types';

export const SUBTITLE_DEFAULT: Subtitle = {
  text: '',
  fontSize: 14,
  fontColor: '255,255,255,1',
  bgColor: '0,0,0,0.5',
  spacing: 0,
  rollingMode: SubtitleRollingMode.left,
  rollingSpeed: 1,
  pauseDuration: 0,
  clickAction: SubtitleClickAction.none,
  clickActionLink: '',
  linkTarget: LinkTarget.blank,
  turnOffBgMusicOnPlay: 0,
};
